/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'abi': {
    width: 158,
    height: 157,
    viewBox: '0 0 158 157',
    data: `<desc>Created using Figma</desc><use xlink:href="#svgicon-abi-a" transform="translate(1)"/><defs><path pid="0" id="svgicon-abi-a" d="M78.5 0L157 78.5 78.5 157 0 78.5 78.5 0z"/></defs>`
  }
})
